import styled from "styled-components";

export const Container = styled.section`
  min-height: inherit;
  display: grid;
  place-items: center;
`;